/**
 * Featured boxes: Swiper carousel on tablet/mobile when block has .is-carousel-on-mobile.
 */
import Swiper from 'swiper/bundle';

const BLOCK_SEL = '.is-carousel-on-mobile';
const GRID_SEL = '.featured-boxes__grid';
const NAV_SEL = '.featured-boxes__nav';
const ITEM_SEL = '.featured-boxes__item';
const TABLET_AND_BELOW = '(max-width: 1024px)';

function carouselConfig(slideCount, nav) {
  const config = {
    slidesPerView: 1,
    spaceBetween: '20px',
    speed: 500,
    grabCursor: true,
    watchOverflow: true,
    loop: slideCount > 3,
    a11y: { enabled: true },
    breakpoints: {
      640: {
        slidesPerView: 2,
      },
      768: {
        slidesPerView: 3,
      },
    },
  };

  if (nav) {
    config.navigation = {
      nextEl: nav.querySelector('.featured-boxes__nav-btn--next'),
      prevEl: nav.querySelector('.featured-boxes__nav-btn--prev'),
    };
  }

  return config;
}

/** Swiper 12 requires .swiper-wrapper > .swiper-slide; wrap existing items without changing the blade. */
function mountSwiperStructure(grid) {
  if (grid.dataset.swiperMounted === 'true') {
    return;
  }

  const items = [...grid.querySelectorAll(`:scope > ${ITEM_SEL}`)];
  if (!items.length) {
    return;
  }

  const wrapper = document.createElement('div');
  wrapper.className = 'swiper-wrapper';

  items.forEach((item) => {
    const slide = document.createElement('div');
    slide.className = 'swiper-slide';
    slide.appendChild(item);
    wrapper.appendChild(slide);
  });

  grid.classList.add('swiper');
  grid.appendChild(wrapper);
  grid.dataset.swiperMounted = 'true';
}

function unmountSwiperStructure(grid) {
  if (grid.dataset.swiperMounted !== 'true') {
    return;
  }

  const wrapper = grid.querySelector('.swiper-wrapper');
  if (wrapper) {
    wrapper.querySelectorAll('.swiper-slide').forEach((slide) => {
      const item = slide.querySelector(ITEM_SEL);
      if (item) {
        grid.appendChild(item);
      }
    });
    wrapper.remove();
  }

  grid.classList.remove('swiper', 'swiper-initialized', 'swiper-horizontal', 'swiper-backface-hidden');
  delete grid.dataset.swiperMounted;
}

function initBlock(block) {
  const grid = block.querySelector(GRID_SEL);
  if (!grid) {
    return;
  }

  const nav = block.querySelector(NAV_SEL);
  const slideCount = grid.querySelectorAll(ITEM_SEL).length;
  const tabletAndBelow = window.matchMedia(TABLET_AND_BELOW);
  let swiper = null;

  function enableCarousel() {
    if (swiper) {
      return;
    }

    mountSwiperStructure(grid);
    swiper = new Swiper(grid, carouselConfig(slideCount, nav));
  }

  function disableCarousel() {
    if (swiper) {
      swiper.destroy(true, true);
      swiper = null;
    }
    unmountSwiperStructure(grid);
  }

  function onBreakpointChange(event) {
    if (event.matches) {
      enableCarousel();
    } else {
      disableCarousel();
    }
  }

  tabletAndBelow.addEventListener('change', onBreakpointChange);

  if (tabletAndBelow.matches) {
    enableCarousel();
  }
}

function initFeaturedBoxesCarousels() {
  document.querySelectorAll(BLOCK_SEL).forEach(initBlock);
}

function whenReady(fn) {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fn, { once: true });
  } else {
    queueMicrotask(fn);
  }
}

whenReady(initFeaturedBoxesCarousels);

if (typeof window.acf !== 'undefined') {
  window.acf.addAction('render_block_preview/type=featured-boxes', initFeaturedBoxesCarousels);
  window.acf.addAction('render_block_preview/type=acf/featured-boxes', initFeaturedBoxesCarousels);
}
